<template>
  <div id="day15" class="dod15">
    <div class="dod15_header" ref="header" data-fixed-sticky>
      <div class="dod15_header_bg" ref="headerBackground" data-fixed-sticky-item="sticky">
        <div class="dod15_header_bg_image" v-bind:style="`background-image: url(${image01})`"></div>
      </div>
      <div class="dod15_header_nav" data-fixed-sticky-item="fixed">
        <div class="dod15_header_nav_logo">LOGO</div>
        <div class="dod15_header_nav_title">15 - Apple Like Scroll Top Effect</div>
      </div>
      <h1 ref="log" data-fixed-sticky-item="center">Sticky</h1>
      <h1 data-fixed-sticky-item="scale">Scale</h1>
    </div>
    <div class="dod15_container">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </div>
  </div>
</template>

<script>
// import { TweenMax, Power4 } from 'gsap/TweenMax'

export default {
  name: 'Day15Page',

  data: () => ({
    items: false,
    image01: require('@/assets/images/dod/texture_0005.jpg')
  }),

  methods: {
    isElementInView(top, bottom) {
      return (bottom >= 0 && top <= window.innerHeight)
    },
    scrollEvent(e) {
      const { top, height, bottom } = this.$refs.header.getBoundingClientRect()
      const scrollTop = (top - window.pageYOffset) / height
      // this.$refs.log.textContent = scrollTop
      for (let item of this.items) {
        const type = item.dataset.fixedStickyItem

        if (type === 'sticky') {
          if (scrollTop > 0) {
            // item.style.position = 'fixed'
            item.style.transform = `scale(${1 + (scrollTop / 2)})`
          } else if (scrollTop < 0 && this.isElementInView(top, bottom)) {
            // item.style.position = 'absolute'
            item.style.transform = `translateY(-${Math.abs(scrollTop) * 30}%)`
          } else {
            // item.style.position = 'absolute'
            item.style.transform = null
          }
        } else if (type === 'fixed') {
          if (scrollTop > 0) {
            item.style.position = 'fixed'
          } else if (scrollTop < 0 && this.isElementInView(top, bottom)) {
            item.style.position = 'absolute'
          } else {
            item.style.position = null
          }
        } else if (type === 'center') {
          if (scrollTop > 0) {
            const scale = 1 + (scrollTop / 2)
            const elH = (height * scale - height) / 2
            item.style.transform = `translateY(-${(elH)}px)`
          } else {
            item.style.transform = null
          }
        } else if (type === 'scale') {
          if (scrollTop > 0) {
            item.style.transformOrigin = 'center'
            item.style.transform = `scale(${1 + (scrollTop / 3)})`
          } else {
            item.style.transform = null
          }
        }
      }
    },
    setHeaderBackgroundSize() {
      const { height } = this.$refs.header.getBoundingClientRect()
      this.$refs.headerBackground.style.height = `${height}px`
    }
  },

  mounted() {
    this.setHeaderBackgroundSize()
    this.items = document.querySelectorAll('[data-fixed-sticky-item]')
  },

  created() {
    window.scrollTo(0, 0)
    window.addEventListener('optimizedScroll', this.scrollEvent, false)
    window.addEventListener('optimizedResize', this.setHeaderBackgroundSize, false)
  },

  beforeDestroy() {
    window.removeEventListener('optimizedScroll', this.scrollEvent, false)
    window.removeEventListener('optimizedResize', this.setHeaderBackgroundSize, false)
  }
}
</script>

<style scoped lang="scss">
.dod15_header {
  @include FR_FLEX_LAYOUT(center, center);
  width: 100%;
  position: relative;
  height: 500px;
  h1 {
    position: relative;
    z-index: 99;
    color: #ffffff;
    font-size: 10vw;
    transform: translateZ(1deg);
    will-change: transform, scroll-position;
    transform-origin: top center;
    backface-visibility: hidden;
    transition: transform 10ms linear;
  }
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    margin-top: -1px;
    background-color: #00ff00;
    z-index: 99;
  }
}

.dod15_header_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #00ff00;
  transform: translateZ(0);
  will-change: transform, scroll-position;
  transform-origin: top center;
  backface-visibility: hidden;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    margin-top: -1px;
    background-color: yellow;
    z-index: 99;
  }
}

.dod15_header_bg_image {
  @include FR_FULLSIZE;
  @include FR_BG;
}

.dod15_header_bg_image:before {
  content: '';
  @include FR_FULLSIZE;
  background-image: linear-gradient(rgba(#000000, 0.4), rgba(#000000, 0.1));
}

.dod15_header_nav {
  @include FR_FLEX_LAYOUT(flex-start, center);
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  color: #ffffff;
  padding: 2rem;
  color: 0 1px 2px rgba(#000000, 0.2);
}

.dod15_header_nav_title {
  @include FONTSIZE(S);
  margin-left: auto;
}

.dod15_header_nav_logo {
  @include FONTSIZE(M, S);
  // font-size: 20px;
  font-weight: bold;
}

.dod15_container {
  background-color: #ffffff;
  padding: 40px;
  position: relative;
  min-height: 200vh;
}
</style>
